import { httpClient } from '../http/httpClient'

export type GetByIdLinkResponse = {
  _id: string
  name: string
  seller: string
  table: string
  simulations_count: number
  createdAt: string
  updatedAt: string
}

export const getByIdLink = async (linkId: string) => {
  const { data } = await httpClient
    .get<GetByIdLinkResponse>(`/self-hire/${linkId}`)
    .catch((error) => {
      throw error?.response?.data || error
    })
  return data
}
